<template>
  <div id="img_test_outer">
    <div>
      <image-clip />
    </div>

  </div>
</template>

<script>
  import ImageClip from "./ImageClip";
export default {
  name: "ImageTest",
  components: {
    ImageClip
  },
}
</script>

<style scoped>

  #img_test_outer {
    position: fixed;
    background-color: rgba(0,0,0,0.3);
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  #img_test_outer > div {
    width: 300px;
    height: 200px;
    background-color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/vue-clip/ImageTest.vue